"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _pushConfig = _interopRequireDefault(require("./pushConfig.vue"));
var _pushHuaWeiConfig = _interopRequireDefault(require("./pushHuaWeiConfig.vue"));
var _pushXiaoMiConfig = _interopRequireDefault(require("./pushXiaoMiConfig.vue"));
var _pushVivoConfig = _interopRequireDefault(require("./pushVivoConfig.vue"));
var _pushHonorConfig = _interopRequireDefault(require("./pushHonorConfig.vue"));
var _pushOppoConfig = _interopRequireDefault(require("./pushOppoConfig.vue"));
var _threePartyConfiguration = require("@/api/appBasicSetup/threePartyConfiguration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    pushConfig: _pushConfig.default,
    pushHuaWeiConfig: _pushHuaWeiConfig.default,
    pushXiaoMiConfig: _pushXiaoMiConfig.default,
    pushVivoConfig: _pushVivoConfig.default,
    pushHonorConfig: _pushHonorConfig.default,
    pushOppoConfig: _pushOppoConfig.default
  },
  data: function data() {
    return {
      loading: false,
      jguangBaseConfig: {},
      huaweiConfig: {},
      oppoConfig: {},
      xiaomiConfig: {},
      vivoConfig: {},
      honorConfig: {}
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      this.loading = true;
      (0, _threePartyConfiguration.queryThirdConfig)({
        type: 1
      }).then(function (res) {
        _this.loading = false;
        _this.jguangBaseConfig = res.data.jigangConfig.jguangBaseConfig;
        _this.huaweiConfig = res.data.jigangConfig.huaweiConfig;
        _this.oppoConfig = res.data.jigangConfig.oppoConfig;
        _this.xiaomiConfig = res.data.jigangConfig.xiaomiConfig;
        _this.vivoConfig = res.data.jigangConfig.vivoConfig;
        _this.honorConfig = res.data.jigangConfig.honorConfig;
      }).catch(function () {
        _this.loading = false;
      });
    },
    jump: function jump(val) {
      window.open(val);
    }
  }
};